import clientEnv from 'utils/global/clientEnv'

// Constants/config for communicating with the Auth Service
// Dynamically generated params like state and code_challenge are generated when required and stored in session

export const authServiceClientId = clientEnv.PUBLIC_CLIENT_AUTH_SERVICE_CLIENT_ID
export const redirectUri = `${window.location.origin}/public/auth/callback`
export const responseType = 'code'
export const scope = 'openid profile email rpp_uuid'
export const pkceCodeChallengeMethod = 'S256'
export const pkceStateKey = 'pkce_state'
export const pkceCodeVerifierKey = 'pkce_code_verifier'
export const grantType = 'authorization_code'
